import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5193 6.16241L1.74934 1.04507C1.24502 0.7508 0.731366 1.4121 1.14126 1.82793L4.88109 5.62192C5.64879 6.40073 5.64861 7.65175 4.88069 8.43035L1.14116 12.2219C0.731134 12.6376 1.24466 13.299 1.74905 13.0049L10.5191 7.88994C11.1806 7.50413 11.1807 6.54836 10.5193 6.16241Z",
		fill: "#1a1a1a"
	})
});
export default SvgIconChevron;
